import {create, StateCreator} from 'zustand';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

const isDevMode = true; // process.env.NODE_ENV === 'development';

// Adds Zustand devtools conditionally
// Works with Redux DevTools browser plugin
// (see: https://github.com/pmndrs/zustand/discussions/2195 for inspiration)
export const createCustomStore = <T extends object>(name: string, fn: StateCreator<T, [['zustand/devtools', never], ['zustand/immer', never]]>) =>
  isDevMode
    ? create(
        devtools(immer(fn), {
          name: 'webapp',
          store: name
        })
      )
    : create(immer(fn));
